import { render, staticRenderFns } from "./ApproMenuIcon.vue?vue&type=template&id=e5bb1c80"
import script from "./ApproMenuIcon.vue?vue&type=script&lang=js"
export * from "./ApproMenuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports